import React from 'react';

/*
  AlertCard — renders a compact alert card for the life-finance right panel.
  Props:
    type     — 'advance-tax' | 'savings-drop' | '80c'
    data     — alert object from API; returns null if falsy
    onDismiss — optional dismiss handler; if provided, shows × button
*/
const AlertCard = ({ type, data, onDismiss }) => {
  if (!data) return null;

  const configs = {
    'advance-tax': {
      bg: 'rgba(245,158,11,0.08)',
      border: '#F59E0B',
      labelColor: '#F59E0B',
      label: 'ADVANCE TAX DUE',
      headline: `${data.label} — ${data.deadline}`,
      sub: `Rs.${Number(data.installmentAmount).toLocaleString('en-IN')} due · ${data.daysLeft} days`,
    },
    'savings-drop': {
      bg: 'rgba(244,63,94,0.06)',
      border: '#F43F5E',
      labelColor: '#F43F5E',
      label: 'SAVINGS RATE DROP',
      headline: `Down ${data.drop}% from last month`,
      sub: `${data.previousRate}% → ${data.currentRate}%`,
    },
    '80c': {
      bg: 'rgba(99,102,241,0.07)',
      border: 'var(--accent)',
      labelColor: '#818CF8',
      label: '80C OPPORTUNITY',
      headline: `Rs.${Number(data.remaining80C).toLocaleString('en-IN')} of limit unused`,
      sub: `Save Rs.${Number(data.taxSaving).toLocaleString('en-IN')} in taxes · ${data.daysLeft} days left`,
    },
  };

  const cfg = configs[type];
  if (!cfg) return null;

  return (
    <div style={{ padding: '10px 12px', background: cfg.bg, borderLeft: `3px solid ${cfg.border}`, borderRadius: '6px', position: 'relative' }}>
      {onDismiss && (
        <button
          onClick={onDismiss}
          style={{ position: 'absolute', top: '8px', right: '8px', background: 'none', border: 'none', color: 'var(--text-tertiary)', fontSize: '13px', cursor: 'pointer', lineHeight: 1, fontFamily: 'inherit', padding: 0 }}
        >×</button>
      )}
      <p style={{ fontSize: '10px', fontWeight: 600, color: cfg.labelColor, textTransform: 'uppercase', letterSpacing: '0.1em', margin: '0 0 3px' }}>{cfg.label}</p>
      <p style={{ fontSize: '12px', fontWeight: 700, color: 'var(--text-primary)', margin: '0 0 2px' }}>{cfg.headline}</p>
      <p style={{ fontSize: '12px', color: 'var(--text-secondary)', margin: 0 }}>{cfg.sub}</p>
    </div>
  );
};

export default AlertCard;
